import { BELGE_GRUBUNA_GORE_RESMI_RUHSAT_SAYILARI } from "../constants/requestUrls";
import { postRequest } from "../request";

const resmiRuhsatBasvuruSayilari = (tempBelgeGrubuId) => {
    let filterModel= {};
    filterModel.BelgeGrubuId=tempBelgeGrubuId;
    const data = JSON.stringify(filterModel);
    return postRequest({url:BELGE_GRUBUNA_GORE_RESMI_RUHSAT_SAYILARI,data});
}

export default resmiRuhsatBasvuruSayilari;